export default __webpack_public_path__ + "static/media/7.b5212154.jpg";